import { Directive, ElementRef, HostListener, Renderer2, RendererStyleFlags2, Input } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';

@Directive({
    selector: '[appColumnResize]'
})
export class ColumnResizeDirective {
    private resizing = false;
    private initialWidth: number;
    private startX: number;

    /**
     * Constructor
     * @param el 
     * @param renderer 
     * @param commonService 
     */
    constructor(private el: ElementRef,
        private renderer: Renderer2,
        private commonService: CommonFunctionalitiesService) { }

    /**ngOnInit */
    ngOnInit() {
        /**setting the border right to the table headers */
        this.renderer.setStyle(this.el.nativeElement, 'border-right', '1px solid #00000029');
    }

    /**Host listener mousedown event */
    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent) {
        this.resizing = true;
        this.initialWidth = this.el.nativeElement.offsetWidth;
        this.startX = event.clientX;
    }

    /**Host listener mousemove event */
    @HostListener('document:mousemove', ['$event'])
    onMouseMove(event: MouseEvent) {
        if (this.resizing) {
            const newWidth = this.initialWidth + (event.clientX - this.startX);
            this.renderer.setStyle(this.el.nativeElement, 'width', `${newWidth}px`);
            /**sending the newWidth and column innerText to service file */
            this.commonService.sendTableWidth({ width: newWidth, innerText: this.el.nativeElement.innerText });
        }
    }

    /**Host listener mouseup event */
    @HostListener('mouseup')
    onMouseUp() {
        this.resizing = false;
        this.renderer.setStyle(this.el.nativeElement, 'cursor', 'e-resize', RendererStyleFlags2.Important);
    }
}